// Central content for Grandview Estate — Canyon Lake, TX
// Managed by Elite STR Hosting Co.
export const BOOK_URL = "https://www.elitestrhostingco.com/rentals/488434";
// Kept for backward-compat imports across components:
export const AIRBNB_URL = BOOK_URL;

export const PROPERTY = {
  name: "Grandview Estate",
  tagline: "Lake View · Waterfront · Pool & Spa · Sleeps 24",
  location: "Canyon Lake, Texas",
  headline: ["Grandview Estate —", "Canyon Lake Luxury"],
  subheadline:
    "An 8-bedroom, 9 bathroom lakefront retreat perched high above Canyon Lake — resort pool & spa, panoramic sunsets, and space for 24 guests.",
  stats: [
    { label: "Guests", value: "24" },
    { label: "Bedrooms", value: "8" },
    { label: "Beds", value: "18" },
    { label: "Bathrooms", value: "9" },
  ],
  pricing: "from $1,205 / night",
};

// Real property photography — Elite STR + official Airbnb photo tour (with real room labels)
const P = {
  // Elite STR (exteriors & great room)
  poolSunset: "https://uc.orez.io/i/5415e12f0f804c208eb292564c027eba-Large",
  sunsetDeck: "https://uc.orez.io/i/a2978ed95fe3473b9d4c913a0b437059-Large",
  exterior:   "https://uc.orez.io/i/c548784603904ed98e7664a0751dfbab-Large",
  entryway:   "https://uc.orez.io/i/5127727b140a4a5eb4729c4f74213e7a-Large",
  greatRoom:  "https://customer-assets-4nw71qhi.emergentagent.net/job_luxury-pool-escape/artifacts/15e90uey_HD_1748982529165_1447_Tamarack_Fossum_Studios_2048px_7C2A7998.jpg",
  // Airbnb interior photos (official captions)
  kitchen1:   "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/152b83a7-3c27-41bb-a236-47bb7451ae98.jpeg?im_w=1440",
  kitchen2:   "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/9e719573-3040-4c9f-aa1b-ac127773af5c.jpeg?im_w=1440",
  dining:     "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/9fb0bbdf-1fd7-4877-aa93-71c4e49ebea3.jpeg?im_w=1440",
  bedroom1:   "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/66045ab5-4e82-441f-9438-dec1ec2465b2.jpeg?im_w=1440",
  bedroom2:   "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/705e3bd9-8ba9-4fae-850d-e111ebdf3f12.jpeg?im_w=1440",
  bedroom3:   "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/fd397806-e654-40e6-bdf6-7fb6001b098f.jpeg?im_w=1440",
  bedroom4:   "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/808e0fed-3de9-489d-9e93-f8dbf9b8596f.jpeg?im_w=1440",
  bedroom5:   "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/3b1fdde9-2c86-43f0-a0e9-9170b00419ea.jpeg?im_w=1440",
  bedroom6:   "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/bc77fd43-2634-4279-9fa5-25fb43f59bb8.jpeg?im_w=1440",
  bedroom7:   "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/b8564d7e-c49c-47d1-a11f-4f39c14b9dc8.jpeg?im_w=1440",
  bedroom8:   "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/391cd5ec-e499-4acf-89ce-e075688c65bd.jpeg?im_w=1440",
  bath1:      "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/ba4caae4-b027-4f44-9f6c-a9a384fa949c.jpeg?im_w=1440",
  bath2:      "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/764ba8a3-42b6-4df9-8c35-8f45a8b32652.jpeg?im_w=1440",
  balcony:    "https://a0.muscache.com/im/pictures/hosting/Hosting-1712012638864594157/original/c9f0734f-c4d3-477a-a26b-4a96ba464441.jpeg?im_w=1440",
  // Owner-supplied Bedroom 3 & 6 — bunks + queen suites
  bedroom3Real: "https://customer-assets-4nw71qhi.emergentagent.net/job_luxury-pool-escape/artifacts/hr69imrh_HD_1748052163427_tp0WwD1m.jpg",
  bedroom6Real: "https://customer-assets-4nw71qhi.emergentagent.net/job_luxury-pool-escape/artifacts/vz99slpk_HD_1748052164311_z1rIqJkC.jpg",
  // Bunk Rooms 1 & 2 — Bunk Room 1 fridge removed via Nano Banana; Bunk Room 2 original
  bunkRoom1: "/bunk-room-1.png",
  bunkRoom2: "https://customer-assets-4nw71qhi.emergentagent.net/job_luxury-pool-escape/artifacts/hc9ia9r2_HD_1748052162523_oWAbKWm_.jpg",
};

export const IMAGES = {
  hero: P.poolSunset,
  sunsetDeck: P.sunsetDeck,
  exterior: P.exterior,
  entryway: P.entryway,
  greatRoom: P.greatRoom,
  bedroom1: P.bedroom1,
};

export const HERO_SLIDES = [P.poolSunset, P.sunsetDeck, P.greatRoom];

// Curated 15-photo bento gallery blending Elite STR hero exteriors with official Airbnb interior shots
export const GALLERY = [
  { src: P.poolSunset, alt: "Resort-style pool at sunset with the estate lit up above the lake", tag: "Pool & Sunset",  span: "md:col-span-8 md:row-span-2" },
  { src: P.greatRoom,  alt: "Living room with vaulted wood ceiling, wall of lake-view windows, fireplace, and stone floors",   tag: "Living Room",   span: "md:col-span-4" },
  { src: P.sunsetDeck, alt: "Upper deck with plunge pool overlooking the sunset over the lake",     tag: "Sunset Deck",   span: "md:col-span-4" },
  { src: P.kitchen1,   alt: "Full chef's kitchen with premium appliances and gas cooking",           tag: "Chef's Kitchen", span: "md:col-span-5" },
  { src: P.dining,     alt: "Spacious dining area seating the entire group",                          tag: "Dining Area",   span: "md:col-span-7" },
  { src: P.kitchen2,   alt: "Wet bar with under-counter fridge, blue tile backsplash, and bar seating", tag: "Wet Bar", span: "md:col-span-4" },
  { src: P.bedroom1,     alt: "Bedroom 1 · King suite with private en-suite bathroom",                     tag: "Bedroom 1 · King", span: "md:col-span-4" },
  { src: P.bedroom2,     alt: "Bedroom 2 · King suite with private en-suite bathroom",                     tag: "Bedroom 2 · King", span: "md:col-span-4" },
  { src: P.bedroom3Real, alt: "Bedroom 3 · Queen bed with twin-over-twin bunks — bright, breezy suite",    tag: "Bedroom 3 · Bunks and Queen", span: "md:col-span-4" },
  { src: P.bedroom4,     alt: "Bedroom 4 · Queen bed with twin-over-twin bunks",                           tag: "Bedroom 4 · Bunks and Queen", span: "md:col-span-6" },
  { src: P.bedroom5,     alt: "Bedroom 5 · Queen bed with twin-over-twin bunks",                           tag: "Bedroom 5 · Bunks and Queen", span: "md:col-span-6" },
  { src: P.bedroom6Real, alt: "Bedroom 6 · Queen bed with twin-over-twin bunks — soft blue accents",       tag: "Bedroom 6 · Bunks and Queen", span: "md:col-span-6" },
  { src: P.bunkRoom1,    alt: "Bedroom 7 · Dedicated bunk room with twin-over-twin bunks and vaulted ceiling", tag: "Bedroom 7 · Bunks", span: "md:col-span-3" },
  { src: P.bunkRoom2,    alt: "Bedroom 8 · Dedicated bunk room with twin-over-twin bunks",                    tag: "Bedroom 8 · Bunks", span: "md:col-span-3" },
  { src: P.bath1,      alt: "Full bathroom 1 with walk-in shower",                                    tag: "Full Bathroom", span: "md:col-span-4" },
  { src: P.balcony,    alt: "Balcony with sweeping Canyon Lake sunset views",                         tag: "Balcony",       span: "md:col-span-8" },
  { src: P.exterior,   alt: "Modern estate exterior with covered wooden entry and metal railings",    tag: "Estate Exterior", span: "md:col-span-7" },
  { src: P.entryway,   alt: "Bright entry hall with wood-look floors and welcoming decor",            tag: "Entryway",      span: "md:col-span-5" },
];

export const AMENITIES = [
  { icon: "Eye", label: "Lake Views" },
  { icon: "Waves", label: "Waterfront" },
  { icon: "Droplets", label: "Pool (Heated & Chilled)" },
  { icon: "ThermometerSun", label: "Hot Tub / Spa" },
  { icon: "Flame", label: "Fire Pit" },
  { icon: "Wifi", label: "Fast Wi-Fi" },
  { icon: "ChefHat", label: "Chef's Kitchen" },
  { icon: "Wind", label: "A/C Throughout" },
  { icon: "Users", label: "Group Retreats" },
  { icon: "PartyPopper", label: "Weddings & Events" },
  { icon: "Sparkles", label: "Luxury Finishes" },
  { icon: "Sun", label: "Upper Sunset Deck" },
];

// Real sleeping arrangements from the listing
// Every bedroom has a private attached full bathroom w/ shower + individual climate control, smart TV, and ceiling fan.
// Bunk rooms are dedicated bunk spaces without individual climate control / TV / fan.
export const SLEEPING = [
  { room: "Bedroom 1", beds: "1 King", note: "Private en-suite bathroom with shower", suite: true },
  { room: "Bedroom 2", beds: "1 King", note: "Private en-suite bathroom with shower", suite: true },
  { room: "Bedroom 3", beds: "Queen + Twin bunk", note: "Private attached bathroom with shower", suite: true },
  { room: "Bedroom 4", beds: "Queen + Twin bunk", note: "Private attached bathroom with shower", suite: true },
  { room: "Bedroom 5", beds: "Queen + Twin bunk", note: "Private attached bathroom with shower", suite: true },
  { room: "Bedroom 6", beds: "Queen + Twin bunk", note: "Private attached bathroom with shower", suite: true },
  { room: "Bedroom 7", beds: "Twin-over-Twin bunks", note: "Dedicated bunk room — additional sleeping space", suite: false },
  { room: "Bedroom 8", beds: "Twin-over-Twin bunks", note: "Dedicated bunk room — adjacent to game area", suite: false },
];

// Perks shared by every private bedroom (not bunk rooms)
export const SUITE_PERKS = [
  { icon: "Bath", label: "Private full bath w/ shower" },
  { icon: "Thermometer", label: "Individual climate control" },
  { icon: "Tv", label: "Smart TV" },
  { icon: "Fan", label: "Ceiling fan" },
];

export const ITINERARIES = [
  {
    n: "01",
    title: "Lakeside Day",
    body: "Sunrise coffee on the upper deck, a lazy morning by the pool, then a short drive to a nearby public park or boat ramp for swimming and boating on Canyon Lake. Wind down with s'mores at the fire pit under Hill Country stars.",
  },
  {
    n: "02",
    title: "Friends Getaway",
    body: "Brunch in the chef's kitchen, an afternoon float on the Guadalupe River, sunset cocktails on the sunset deck, and live music in the Gruene Historic District after dark.",
  },
  {
    n: "03",
    title: "Celebrations & Retreats",
    body: "This estate was built for weddings, milestone birthdays, and corporate retreats — expansive indoor-outdoor spaces, private suites for every guest, and paradise just outside the door.",
  },
];

// Nearby attractions (from listing) — lake access via public parks & boat ramps a few minutes away
export const DRIVE_TIMES = [
  { place: "Public parks & boat ramps", time: "Minutes" },
  { place: "Canyon Lake · boating & swimming", time: "Minutes" },
  { place: "Guadalupe River tubing", time: "Nearby" },
  { place: "Gruene Historic District", time: "20 min" },
  { place: "Schlitterbahn Waterpark", time: "25 min" },
  { place: "Natural Bridge Caverns", time: "25 min" },
  { place: "Hill Country wineries", time: "30 min" },
  { place: "San Antonio Intl. (SAT)", time: "55 min" },
  { place: "Austin-Bergstrom (AUS)", time: "75 min" },
];

export const HOUSE_RULES = [
  { icon: "Clock", label: "Check-in after 3:00 PM" },
  { icon: "Clock", label: "Checkout before 11:00 AM" },
  { icon: "CigaretteOff", label: "No smoking indoors" },
  { icon: "Moon", label: "Quiet hours after 10 PM" },
  { icon: "PartyPopper", label: "Weddings & events welcome" },
  { icon: "Users", label: "Up to 24 adult guests" },
  { icon: "KeyRound", label: "Smart-lock self check-in" },
  { icon: "Car", label: "On-site parking" },
];

// Important safety notice from the listing — shown to guests before booking
export const SAFETY_NOTICE = {
  title: "Child Safety Notice",
  body: "This property is not recommended for young children who require close supervision or for non-swimmers. The deck features a decorative horizontal railing that may create a ladder-like climbing hazard for children. The property is not equipped with pool alarms or child safety door latches, and there is a 30-foot drop by the front door. Parents and guardians are responsible for providing constant supervision of children while on the property.",
};

export const HOST = {
  name: "Elite STR Hosting Co.",
  role: "Professional Hospitality Team",
  bio: "Grandview Estate is professionally managed by Elite STR Hosting Co. — a dedicated hospitality team specializing in luxury Canyon Lake retreats. From seamless smart-lock check-in to 24/7 guest support, every detail is curated so your group can focus on what matters: unforgettable moments together.",
  responseTime: "Typically responds within an hour",
  perks: [
    "Concierge event planning",
    "24/7 guest support",
    "Fully stocked chef's kitchen",
    "Fresh linens & premium amenities",
  ],
};

export const FAQS = [
  { q: "How many guests can Grandview Estate host?", a: "The estate comfortably accommodates up to 24 guests across 8 bedrooms — including 6 private suites with attached bathrooms and 2 bunk rooms — with 18 beds and 9 full bathrooms total." },
  { q: "Is the pool and spa heated?", a: "Yes — the resort-style pool and spa can be both heated and chilled year-round for the ultimate luxury experience in any season." },
  { q: "Can we host a wedding or private event?", a: "Absolutely. Grandview Estate was designed for weddings, milestone celebrations, and corporate retreats. Message us to discuss event details, guest counts, and vendor coordination." },
  { q: "How close is the lake and what's nearby?", a: "The estate sits on the waterfront with sweeping lake views — swimming access is available at nearby public parks and boat ramps just minutes away. You'll also find Guadalupe River tubing, Gruene Historic District, Schlitterbahn Waterpark, Natural Bridge Caverns, and Hill Country wineries close by." },
  { q: "What's provided vs. what should we bring?", a: "We provide fresh linens, plush towels, a fully stocked chef's kitchen (cookware, serving pieces, utensils), high-speed Wi-Fi, and premium starter amenities. Guests typically bring groceries, beach towels, and any specialty items." },
  { q: "What are the check-in and quiet-hour rules?", a: "Check-in is after 3:00 PM and checkout by 11:00 AM (self-check-in via smart lock). Quiet hours begin at 10 PM. No smoking indoors." },
];
